import { useLocation } from "react-router-dom";
import { useWakeLock } from "../lib/useWakeLock.js";

/**
 * Route-aware screen wake lock. Mounted once in App; keeps the screen awake on
 * the surfaces where a learner reads/answers for long stretches and would
 * otherwise watch the phone dim mid-passage: drills, the practice-test runner,
 * the daily Hidden Test, and mistake review. Released everywhere else.
 */
export function WakeLock() {
  const { pathname } = useLocation();
  const active =
    pathname.startsWith("/app/drill") ||
    pathname.startsWith("/app/practice-test/run") ||
    pathname.startsWith("/app/hidden-test") ||
    pathname.startsWith("/app/mistakes");
  useWakeLock(active);
  return null;
}
